











































import { Component, Vue } from "vue-property-decorator";
import ExpenseRow from "./ExpenseRow.vue";

@Component({
  components: {
    ExpenseRow
  }
})
export default class ExpenseItemListHeader extends Vue {}
